import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { HTTPService } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { AddressAppProps } from "./address";
import React from "react";
export default class ContactPersons extends React.Component<AddressAppContactsProps, { selected: any }>{
    private gridData = [];
    private gridOptions = {};
    private translations = {};
    private dataUrl: string;
    private colors = {
        main: "#90caf9",
        inactiv: "#ef9a9a"
    }


    constructor(props) {
        super(props);
        this.dataUrl = "Address/InitContactView?id=" + encodeURIComponent(this.props.entity.AdrNr);
        this.gridOptions = this.props.context.contactsGrid;
        this.translations = this.props.translations;
        this.state = {
            selected: null
        }
    }

    private getGridData() {
        HTTPService.get(this.dataUrl)
            .then(result => {
                this.gridData = result.Data;
                this.setState({});
            });
    }

    private openEditWindow = (dataItem = null) => {
        const url = dataItem ? 'Contact/Edit?isWindow=true&id=' + encodeURIComponent(dataItem.Pos) :
            'Contact/New?isWindow=true&adrNr=' + encodeURIComponent(this.props.context.keyVal1);

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true, preventUrlChangeOnNew: !Helper.hasValue(dataItem) });
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this.getGridData();
        });
        sheet.bind(SheetEventType.ItemDeleted, (target) => {
            this.getGridData();
        });
    }


    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.openEditWindow();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this.openEditWindow(dataItem);
        }
    }

    private handleDataBound = (e) => {
        var data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].Inaktiv) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td", row);
                cell.css("background-color", this.colors.inactiv);
                cell.css("color", "#000000");
            } else if (data[i].Master) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td", row);
                cell.css("background-color", this.colors.main);
                cell.css("color", "#000000");
            }
        }
    }
    private createInfo = () => {
        let baseStyle: React.CSSProperties = {
            display: "inline - block",
            color: "#333",
            width: "240px",
            height: "auto",
            margin: "3px",
            padding: "5px",
            textAlign: "center",
            verticalAlign: "central",
            borderStyle: "solid",
            borderColor: "#333",
            borderWidth: "1px",
            cursor: "default"
        };
        let style_main = JSON.parse(JSON.stringify(baseStyle));
        style_main.backgroundColor = this.colors.main;

        let style_inactiv = JSON.parse(JSON.stringify(baseStyle));
        style_inactiv.backgroundColor = this.colors.inactiv;

        return (
            <>
                <div className="servRepStatus">
                    <span className="servRepStatus__title">{this.translations["Standard.Information"]}</span><br />
                    <div style={style_main}>{this.translations["Field.Ansprechpartner.master"]}</div>
                    <div style={style_inactiv}>{this.translations["Field.Ansprechpartner.inaktiv"]}</div>
                </div>
            </>
        );
    }

    componentDidMount() {
        this.getGridData();
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [];
        const customButtons: Array<GridCustomToolBarButton> = [];

        let enabled = this.props.entity.RecordRight.CanWrite && this.props.entity.ContactRights.CanWrite;
        if (enabled) {
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this.translations["Standard.Neu"], enabled: enabled });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this.translations["Standard.Editieren"], enabled: enabled });
        } else if (this.props.entity.ContactRights.CanRead) {
            customButtons.push({ caption: this.translations["Standard.Öffnen"], enabled: Helper.hasValue(this.state.selected), iconClass: "k-i-eye", id: "show", autoEnabledOnRecordSelected: true });
        }
        const content = <Grid
            data={this.gridData}
            options={this.gridOptions}
            id="addressContacts"
            standardButtons={standardButtons}
            customButtons={customButtons}
            onClickStandardButton={this.handleClickStandardButton}
            onDataBound={this.handleDataBound}
            onSelectionChanged={(dataItem) => { this.setState({ selected: dataItem }) }}
            onClickCustomButton={(id: string) => { if (id === "show") { this.openEditWindow(this.state.selected) } }}

        />

        return (
            <div style={{ display: "grid", gridTemplateRows: "115px auto", gridTemplateColumns: "auto", height: "100%" }}>
                <div style={{ gridColumn: "1/2", gridRow: "1/2" }}>
                    {this.createInfo()}
                </div>
                <div style={{ gridColumn: "1/2", gridRow: "2/3" }}>
                    {content}
                </div>
            </div>
        );
    }
}

interface AddressAppContactsProps extends AddressAppProps {
    translations: Array<string>;
}